/* eslint-disable @typescript-eslint/no-explicit-any */
import i18n from 'i18next';
import API_URLS from '../../constants/api-urls';
import { SCHOOL_TYPES } from '../../constants/school-types';
import axios from '../../utils/axios';

const splitColumns = (number: number) => {
    const newArr = [0, 0, 0];

    for (let i = 0, k = 0; i < number; i++, k++) {
        if (k === 3) {
            k = 0;
        }
        newArr[k] += 1;
    }

    return newArr;
};

type Outputs = 'original' | 'regrouped';

type ResponseType = any;

export type SchoolMenuFilter = {
    id: number | string;
    link: string;
    title: string;
    children?: SchoolMenuFilter[];
    shortTitle?: string;
    slug?: string;
    type?: string;
};

type SchoolMenuAuthor = {
    image_path: string;
    public_name: string;
    slug: string;
    type: string;
    user_id: number;
    world: string;
};

type OriginalAuthors = {
    [SCHOOL_TYPES.PRIMARY_SCHOOL]: SchoolMenuAuthor[];
    [SCHOOL_TYPES.SECONDARY_SCHOOL]: SchoolMenuAuthor[];
};

type OriginalFilters = {
    [SCHOOL_TYPES.PRIMARY_SCHOOL]: SchoolMenuFilter[];
    [SCHOOL_TYPES.SECONDARY_SCHOOL]: SchoolMenuFilter[];
};

type RegroupedFilters = {
    [SCHOOL_TYPES.PRIMARY_SCHOOL]: SchoolMenuFilter[][];
    [SCHOOL_TYPES.SECONDARY_SCHOOL]: SchoolMenuFilter[][];
};

type Lists = {
    original: OriginalFilters;
    regrouped: RegroupedFilters;
};

type HeaderSchoolMenu = {
    authors: OriginalAuthors;
    classes: OriginalFilters;
    fetch: (arg: ResponseType) => void;
    fetched: boolean;
    taxonomy: {
        getListByType: <T extends Outputs, K extends SCHOOL_TYPES>(ouput: T, schoolType: K) => Lists[T][K];
        lists: Lists;
        regroupCategories: (type: string, categories: SchoolMenuFilter[]) => SchoolMenuFilter[][];
        setMenuLists: (arg: { subjects: OriginalFilters }) => void;
    };
    themes: OriginalFilters;
};

const headerSchoolMenu: HeaderSchoolMenu = {
    authors: {} as OriginalAuthors,
    classes: {} as OriginalFilters,
    fetch(cb) {
        if (this.fetched) {
            cb();

            return;
        }

        axios.get(API_URLS.SCHOOL_MENU).then((res: ResponseType) => {
            this.themes = res.themes;
            this.classes = res.classes;
            this.authors = res.authors;
            this.taxonomy.setMenuLists(res);
            this.fetched = true;

            cb(res);
        });
    },
    fetched: false,
    taxonomy: {
        getListByType(origin, type) {
            return this.lists[origin][type] || {};
        },
        lists: {
            original: {} as OriginalFilters,
            regrouped: {} as RegroupedFilters
        },
        regroupCategories(type, categories) {
            const groups = [] as SchoolMenuFilter[][];
            const categoriesCopy = categories.slice();
            const columnsConfig = splitColumns(categoriesCopy.length); // move calculation down in case of seller campaign

            categoriesCopy.push({
                children: [],
                id: '',
                link: '',
                title: i18n.t('header.schoolMenu.otherSubject'),
                type: 'seller'
            });

            columnsConfig.forEach((number) => groups.push(categoriesCopy.splice(0, number)));

            return groups;
        },
        setMenuLists({ subjects }) {
            this.lists.original = subjects;

            Object.keys(subjects).forEach((type) => {
                this.lists.regrouped[type] = this.regroupCategories(type, subjects[type]);
            });
        }
    },
    themes: {} as OriginalFilters
};

export default headerSchoolMenu;
